import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router';
import { Button } from '../../components/ui/button';
import Input from '../../components/ui/input';
import Breadcrumb from '../../components/Breadcrumb';
import { PROMOMANAGE_PAGE } from '../../routes/routeConstant';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { FileUpload } from '../../components/InputImage';
import { IPromotion } from '../../types/types';
import usePromotion from '../../stores/usePromo';
import useServices from '../../stores/useServices';
import InputEn from '../../components/InputEn';

export default function FormPromo() {
  const breadcrumbPath = [{ name: 'Promo', link: PROMOMANAGE_PAGE }, { name: 'Form Promo' }];
  const [searchParams, setSearchParams] = useSearchParams();
  const { promotions, saveLoading, fetchPromotions, editPromotion, addPromotion } = usePromotion();
  const { services, fetchServices } = useServices();
  const editId = searchParams.get('edit');
  const [currentImage, setCurrentImage] = useState<string>('/assets/no-data-image.svg');

  const { register, handleSubmit, setValue, watch, reset } = useForm<IPromotion>({
    defaultValues: {
      name_prm: '',
      name_prm_en: '',
      price_prm: undefined,
      image_prm: '',
    },
  });

  useEffect(() => {
    fetchPromotions();
    fetchServices();
  }, [fetchPromotions, fetchServices]);

  useEffect(() => {
    if (editId) {
      const promoToEdit = promotions?.find((promo) => promo.promo_id === Number(editId));
      if (promoToEdit) {
        setValue('name_prm', promoToEdit.name_prm);
        setValue('name_prm_en', promoToEdit.name_prm_en);
        setValue('price_prm', Number(promoToEdit.price_prm));
        setValue('service_id', promoToEdit.service?.service_id);
        setValue('image_prm', promoToEdit.image_prm);
        setCurrentImage(promoToEdit.image_prm || '/assets/no-data-image.svg');
      }
    }
  }, [editId, promotions, setValue]);

  const onSubmit = async (data: IPromotion) => {
    const modifiedData = {
      ...data,
      price_prm: Number(data.price_prm),
    };
    if (editId) {
      await editPromotion(Number(editId), modifiedData);
      setSearchParams({ tab: 'list' });
    } else {
      await addPromotion(modifiedData);
      setSearchParams({ tab: 'list' });
    }
    reset();
    setCurrentImage('/assets/no-data-image.svg');
  };

  const handleTabClick = () => {
    searchParams.get('tab');
    setSearchParams({ tab: 'list' });
  };

  return (
    <div className="flex gap-4 flex-col">
      <Breadcrumb paths={breadcrumbPath} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Name <span className="text-red-600">*</span>
            </p>
            <InputEn
              type="text"
              nama="name_prm"
              namaEn="name_prm_en"
              placeholder="Masukkan nama produk..."
              register={register}
              watch={watch}
              setValue={setValue}
            />
          </div>

          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Price <span className="text-red-600">*</span>
            </p>
            <Input
              {...register('price_prm')}
              type="number"
              required
              name="price_prm"
              placeholder="Harga mulai dari..."
            />
          </div>

          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Service <span className="text-red-600">*</span>
            </p>
            <Select
              value={watch('service_id') ? String(watch('service_id')) : undefined}
              onValueChange={(value) => setValue('service_id', Number(value))}
              required
            >
              <SelectTrigger className="focus:outline-none focus:ring-1 focus:ring-blue-500">
                <SelectValue placeholder="Pilih layanan" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {services?.map((srv) => (
                    <SelectItem key={srv.service_id} value={String(srv.service_id)}>
                      {srv.name_srv_id}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div className="flex flex-col text-sm w-full mt-2 gap-2">
            <p className="flex gap-1">
              Image <span className="text-red-600">*</span>
            </p>
            <FileUpload
              setValue={setValue}
              register={register}
              imageFieldName="image_prm"
              defaultImage={currentImage}
            />
          </div>
          <div className="flex gap-2">
            <Button variant="secondary" type="button" onClick={handleTabClick}>
              Batal
            </Button>
            <Button type="submit" disabled={saveLoading}>
              {saveLoading ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
